<template>
	<div class="mb-1 text-xs font-semibold text-black uppercase">
		<slot />
	</div>
</template>
